// extracted by mini-css-extract-plugin
export default {"container":"_5b7efb1f","headerContainer":"_c137ca80","checkbox":"_9da08eb","label":"_62f90fbe"};